(() => {
  function initSection(sectionEl) {
    if (!sectionEl) return;

    const track = sectionEl.querySelector('[data-hc-track]');
    if (!track) return;

    // évite double init
    if (track.dataset.hcInit === "1") return;
    track.dataset.hcInit = "1";

    const slides = Array.from(track.querySelectorAll('.hc-about__slide'));
    const prevBtn = sectionEl.querySelector('[data-hc-prev]');
    const nextBtn = sectionEl.querySelector('[data-hc-next]');
    if (slides.length < 2) return;

    let i = 0;
    const mod = (n) => (n + slides.length) % slides.length;

    function render() {
      slides.forEach(s => s.classList.remove('is-active','is-prev','is-next'));
      const prev = mod(i - 1);
      const next = mod(i + 1);
      slides[i].classList.add('is-active');
      slides[prev].classList.add('is-prev');
      slides[next].classList.add('is-next');
    }

    function go(delta) {
        track.style.transform = "scale(1.01)";
setTimeout(() => track.style.transform = "scale(1)", 150);
      i = mod(i + delta);
      render();
    }

    prevBtn && prevBtn.addEventListener('click', (e) => { e.preventDefault(); go(-1); });
    nextBtn && nextBtn.addEventListener('click', (e) => { e.preventDefault(); go(1); });

    // swipe
    let startX = null;

    track.addEventListener('touchstart', (e) => {
      startX = e.touches[0].clientX;
    }, { passive: true });

    track.addEventListener('touchend', (e) => {
      if (startX == null) return;
      const endX = e.changedTouches[0].clientX;
      const dx = endX - startX;
      if (Math.abs(dx) > 35) go(dx > 0 ? -1 : 1);
      startX = null;
    }, { passive: true });

    // 1er rendu
    render();
  }

  function initAll(root = document) {
    root.querySelectorAll('[data-hc-about]').forEach(initSection);
  }

  document.addEventListener('DOMContentLoaded', () => initAll(document));

  // Shopify editor (reload de section)
  document.addEventListener('shopify:section:load', (event) => {
    initAll(event.target);
  });
})();
